export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export function setupMobileAutoScroll() {
  if (isMobile) {
    document.addEventListener('DOMContentLoaded', () => {
      document.documentElement.setAttribute('draggable', 'false');
    });
    document.addEventListener('dragstart', e => {
      e.preventDefault();
    });
  }
  document.addEventListener('focusin', e => {
    if (!isMobile) return;
    const el = e.target;
    if (!el) return;
    const tag = el.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') {
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    }
  });
}
